import CookieSettingsForm from './CookieSettingsForm.vue';
import UserFollowSettingsModal from './UserFollowSettingsModal.vue';
import UserLoginModal from './UserLoginModal.vue';
import UnauthenticatedUserFollowProjectModal from './Modals/UnauthenticatedUserFollowProject/UnauthenticatedUserFollowProjectModal.vue';

export default {
    UserLoginModal,
    CookieSettingsForm,
    UserFollowSettingsModal,
    UnauthenticatedUserFollowProjectModal,
};
